var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessanger = function SvgMessanger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#messanger_svg__a)",
    fillRule: "evenodd",
    d: "M1.042 9.271c0-4.618 4.085-8.23 8.958-8.23s8.958 3.612 8.958 8.23-4.084 8.23-8.958 8.23a10 10 0 0 1-1.638-.14l-3.084 1.532a.625.625 0 0 1-.903-.56v-1.378l-.001-1.29C2.36 14.173 1.042 11.88 1.042 9.272m13.512-.531a1 1 0 0 0-1.2-1.6l-2.459 1.844-.782-1.166a1 1 0 0 0-1.43-.242l-3.237 2.427a1 1 0 0 0 1.2 1.6L9.04 9.808l.782 1.165a1 1 0 0 0 1.43.243z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "messanger_svg__a",
    x1: 1.042,
    x2: 18.958,
    y1: 10,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6701A9"
  })))));
};
export default SvgMessanger;